<template>
<div id="container">
    <div class="container_wrap">
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import { SDLUtil }	from '@/utils';
export default {
    name: 'GSPNConMain',
    created() {
    	const fullPath = this.$route.fullPath || '';
    	if(SDLUtil.isLogin() && fullPath === '/basis/common/gspnCon/commonConnectNew') {
    		this.$router.push({ name: 'GSPNConKnowledgeList' });
    	}
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/GSPNConMain.vue